export enum Role {
    VISITOR,
    USER,
    RETAILER,
    ADMIN,
    SUPERADMIN
}